const APP_NAME     = 'Locomotive';
const DATA_API_KEY = '.data-api';

const html         = document.documentElement;
const body         = document.body;
const isDebug      = html.hasAttribute('data-debug');

// ==========================================================================
// GL TEST
// ==========================================================================
const canvas = document.createElement('canvas');
let gl;

try {
  gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
} catch (e) {
    console.error(e)
}

const SUPPORT_WEBGL = gl ? true : false;
if(!SUPPORT_WEBGL) {
    html.classList.add('has-no-webgl-support')
    alert('Your browser does not support WebGL. Unfortunately that means you will not get the full experience from our website and miss out on cool features. We recommend you to update your browser to a modern version!')
}

const models = [];

export { APP_NAME, DATA_API_KEY, SUPPORT_WEBGL, html, body, isDebug, models };
